import {createCropsDetailsCall} from './digidiary.service';
import {handleAlert} from './sagaHelper';
import {getCustomerId} from './selectors';

import {DD_ADD_NEW_CROP, PUSH_DIGIDIARY_VIEW} from '../actions';

import {call, put, select, takeEvery} from 'redux-saga/effects';

export function* addNewCropDetails({data}) {
  const customerId = yield select(getCustomerId);
  const payload = {...data, cropName: 'paddy', customerId: customerId};
  const response = yield createCropsDetailsCall(customerId, payload);
  if (response.statusCode && response.statusCode === 200) {
    let newView = 'myFarm';
    yield put({type: PUSH_DIGIDIARY_VIEW, newView});
    yield call(handleAlert, {variant: 'success', type: 'addCropSuccess'});
  } else {
    yield call(handleAlert, {variant: 'error', type: 'alertError'});
  }
}

export function* addCropWatcher() {
  yield takeEvery(DD_ADD_NEW_CROP, addNewCropDetails);
}
